module.exports = __webpack_public_path__ + "static/media/cactus_2.2bda82af.png";